<div class="top-band" >

  <!-- <div style="height: 100%; display: inline;"> -->

    <div class="main-text" *ngIf="setupObs | async as setup" (click)="onBack()">🡨 {{ setup.title }}</div>

  <!-- </div> -->

</div>


<nav mat-tab-nav-bar mat-stretch-tabs="false" mat-align-tabs="start" backgroundColor="theme" class="navbar1" [tabPanel]="tabPanel">
  
  <ng-container *ngIf="setupObs | async as setup">
  <a mat-tab-link *ngFor="let link of setup.links" (click)="activeLink = link.name" [active]="activeLink == link.name"
    [routerLink]="[link.path]"> {{link.name}} </a>
  </ng-container>
  <a mat-tab-link></a>
</nav>


<mat-tab-nav-panel #tabPanel>
</mat-tab-nav-panel>
<router-outlet></router-outlet>
